import useNotificationHandler from "hooks/useNotificationHandler";
import { MUTATION_KEYS, QUERY_KEYS } from "library/shared";
import { Attachment } from "library/types";
import { useMutation, useQueryClient } from "react-query";
import api from "service/api";
import { useInvalidateBenefitImplementations } from "./useGetBenefitImplementations";

type Params = {
  countryCode: number | string;
  benefitCategoryTag: number | string;
  clientInternalNumberGOS: number | string;
  benefitImplementationTag: number | string;
  attachmentName: string;
  payload: Attachment;
};
const updateAttachment = async ({
  countryCode,
  clientInternalNumberGOS,
  benefitCategoryTag,
  benefitImplementationTag,
  attachmentName,
  payload,
}: Params) => {
  const response = await api.patch(
    `/benefitimplementation/attachment/${countryCode}/${clientInternalNumberGOS}/${benefitCategoryTag}/${benefitImplementationTag}/${attachmentName}`,
    payload
  );

  return response.data as Attachment;
};
export function useUpdateBenefitImplementationAttachment(refetch = true) {
  const queryClient = useQueryClient();
  const { handleAddAxiosErrorNotification } = useNotificationHandler();
  const invalidateBenefitImplementations =
    useInvalidateBenefitImplementations();

  return useMutation(updateAttachment, {
    mutationKey: MUTATION_KEYS.updateBenefitImplementationAttachment,
    onSuccess: () => {
      if (refetch) {
        invalidateBenefitImplementations();
      }
    },
    onError: (error) => {
      // handle error
      handleAddAxiosErrorNotification(error);
    },
  });
}
